import type { ReactElement } from 'react';

import { isDebugDumpActive } from '@iconik-io/core/src/debug_logger/debug_logger';
import type { StoreEntityKey } from '@iconik-io/shared-lib/src/redux/entities/types';

import { useAppSelector } from '../../store/react_redux_typed';
import DebugDump from '../debug_dump/debug_dump';

const namesMap: Record<StoreEntityKey, string> = {
  acl_templates: 'ACL Template',
  application_tokens: 'Token',
  applications: 'Application',
  asset_persons: 'Asset Person',
  asset_relations: 'Relation',
  assets: 'Asset',
  approvals: 'Approval',
  approval_requests: 'Approval Request',
  automations: 'Automation',
  collection_keyframes: 'Collection Keyframe',
  collections: 'Collection',
  custom_actions: 'Custom Action',
  discoveries: 'Discovery',
  discoveries_admin: 'Admin Discovery',
  export_locations: 'Export Location',
  file_sets: 'File Set',
  files: 'File',
  formats: 'Format',
  groups: 'Group',
  groups_basic: 'Basic Group',
  identity_providers: 'Identity Provider',
  jobs: 'Job',
  keyframes: 'Keyframe',
  logos: 'Logo',
  metadata_fields: 'Field',
  metadata_unmerged_views: 'Unmerged View',
  metadata_user_fields: 'User Field',
  metadata_views: 'Metadata View',
  search_views: 'Search View',
  notifications: 'Notification',
  person_instances: 'Person Instance',
  persons: 'Face Recognition',
  playlists: 'Playlists',
  portals: 'Portal',
  projects: 'Project',
  proxies: 'Proxy',
  recycle_bin_file_sets: 'Bin File Set',
  recycle_bin_formats: 'Bin Format',
  relation_types: 'Relation Type',
  role_groups: 'Role Group',
  role_groups_basic: 'Basic Role Group',
  saved_search_results: 'Search Result',
  saved_searches: 'Search',
  search_backends: 'Search Backend',
  search_history: 'History',
  search_items: 'Search Item',
  segments: 'Segment',
  share_users: 'Share User',
  shares: 'Share',
  storage_gateways: 'Iconik Storage Gateway',
  storage_gateway_clusters: 'ISG Cluster',
  storages: 'Storage',
  system_domains: 'System Domain',
  system_domains_basic: 'Basic System Domain',
  system_logs_recipients: 'Recipient',
  teams: 'Team',
  teams_basic: 'Basic Team',
  themes: 'Theme',
  transcoders: 'Transcoder',
  transcription_properties: 'Transcription Properties',
  users: 'User',
  users_basic: 'Basic User',
  recent_search_items: 'Recent Search Items',
  webhooks: 'Webhook',
  subtitles: 'Subtitles',
};

type Props = {
  entityKey: StoreEntityKey;
  id: string;
};

const DebugDumpEntity = (props: Props): ReactElement | null => {
  const data = useAppSelector(
    (state) => state.entities[props.entityKey]?.[props.id],
  );
  const label = namesMap[props.entityKey];

  if (!isDebugDumpActive) {
    return null;
  }

  return <DebugDump label={label} data={data} />;
};

export default DebugDumpEntity;
